import { resetWidget } from "@/CommonDP/VForm/utils";
export function resetNumber() {
  resetWidget('number', (schema) => {
    schema.options.controls = false;
    schema.options.prefix = '';
    schema.options.suffix = '';
    schema.options.formatNum = true;
    delete schema.options.labelIconClass;
    delete schema.options.labelIconPosition;
    delete schema.options.labelTooltip;
    schema.component = require('./index.vue').default;
    schema.advanced = function () {
      return { controls() { return import('./setting.vue'); } };
    };
    return schema;
  });
}
